<template>
  <div class="EventResourceSearch">
    <Row :gutter="4" style="margin-bottom: 10px;">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
            @on-change="getAccount()"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
    </Row>
    <Row :gutter="4">
      <!-- 选择账号 -->
      <Col span="5">
        <Select
          v-model="accountIds"
          filterable
          multiple
          :max-tag-count="1"
          :placeholder="$t('RAM.common.PleaseSelectAccount')"
          :transfer="true"
        >
          <Checkbox
            v-model="singleAccount"
            @on-change="selectAllAccount"
            style="display: block;text-align:right;"
            v-if="accountList.length > 0"
            >{{ $t("alarms.common.allSelected") }}
          </Checkbox>
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </Col>
      <!-- 选择资源类型 -->
      <Col span="5">
        <Select
          v-model="resourceType"
          :placeholder="$t('RAM.common.PleaseSelectResourceType')"
          :transfer="true"
        >
          <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
          <Option
            :value="item.id"
            v-for="item in resourceTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <!-- 选择事件类型 -->
      <Col span="5">
        <Select
          v-model="eventTypes"
          filterable
          multiple
          :max-tag-count="1"
          :placeholder="$t('RAM.common.PleaseSelectEventType')"
          :transfer="true"
        >
          <Checkbox
            v-model="singleEvent"
            @on-change="selectAllEvent"
            style="display: block;text-align:right;"
            >{{ $t("alarms.common.allSelected") }}
          </Checkbox>
          <Option
            :value="item.id"
            v-for="item in eventTypeList"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>

      <Col span="5">
        <DatePicker
          v-model="timeList"
          type="daterange"
          placement="bottom-end"
          :placeholder="$t('RAM.common.PleaseSelectTimeRange')"
          style="width: 100%"
        ></DatePicker>
      </Col>
      <Col span="2">
        <Button
          type="primary"
          v-hasPermission="['resourceConfigurationManagement:aws:event:page']"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../../../utils/cookieUtil.js";
import TableEventResource from "../event/TableEventResource";

var tableEventResource = TableEventResource;
export default {
  name: "EventResourceSearch",
  data() {
    return {
      company: getCookie(global.companyId),
      companyId: "",
      companyList: [],
      accountList: [],
      accountIds: [],
      singleAccount: false,
      singleEvent: false,
      eventTypeList: [],
      eventTypes: [],
      eventType: "",
      resourceType: "",
      timeList: [],
      timer: "",
      resourceTypeList: []
    };
  },
  mounted: function() {
    if (this.company == 1) {
      this.getCompanyDropDownBox();
    }
    this.getAccount();
    this.getEventTypes();
    this.getResourceTypes();
  },
  methods: {
    getData() {
      eventBus.$emit("companyId", this.companyId);
      eventBus.$emit("accountIds", this.accountIds);
      eventBus.$emit("resourceType", this.resourceType);
      eventBus.$emit("eventTypes", this.eventTypes);
      if (this.timeList != null && this.timeList != undefined) {
        eventBus.$emit("timeList", this.timeList);
      }
      // 调用查询接口
      tableEventResource.methods.showAll();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    getEventTypes: function() {
      this.$api.event
        .getEventTypes("userName", getCookie(global.cookieName))
        .then(res => {
          this.eventTypeList = res.data;
        });
    },
    getResourceTypes: function() {
      this.$api.event
        .getResourceTypes("userName", getCookie(global.cookieName))
        .then(res => {
          this.resourceTypeList = res.data;
        });
    },
    /****************************账号******************************/
    // 查询账号
    getAccount: function() {
      // 清空数组
      this.accountList = [];
      // 清空选中的数据
      this.accountIds = [];
      // 清空复选框
      this.singleAccount = false;
      // 如果不是冠闵用户
      if (this.company != 1) {
        this.companyId = this.company;
      }
      // 账号下拉框
      this.$api.account
        .queryAccountListByCompanyIdAndCloudType({
          companyId: this.companyId,
          cloudPlatformType: 0
        })
        .then(res => {
          if (res.data != null && res.data.length > 0) {
            this.accountList = res.data;
            // 默认全选账户
            for (var i = 0; i < this.accountList.length; i++) {
              this.accountIds.push(this.accountList[i].id);
            }
            this.singleAccount = true;
          }
        });
    },
    // 全选账号
    selectAllAccount() {
      this.accountIds = [];
      if (this.singleAccount) {
        this.accountList.map(item => {
          this.accountIds.push(item.id);
        });
      } else {
        this.accountIds = [];
      }
    },
    // 全选事件类型
    selectAllEvent() {
      this.eventTypes = [];
      if (this.singleEvent) {
        this.eventTypeList.map(eventType => {
          this.eventTypes.push(eventType.id);
        });
      } else {
        this.eventTypes = [];
      }
    }
  }
};
</script>
<style scoped>
.EventResourceSearch {
  padding: 4px 0px 15px 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/event/EventResourceSearch.vue